// extracted by mini-css-extract-plugin
export default {"passwordManagerLayout":"password_passwordManagerLayout__e-NYR","passwordList":"password_passwordList__QGqj2","divider":"password_divider__75n61"};